import { ErrorBoundary } from "react-error-boundary";
import { Navigate, useLocation } from "react-router";

import { useCurrentUser } from "Auth/Hooks/useCurrentUser";
import type { AccessRoleCode } from "Infrastructure/Api/Api";
import { ApplicationErrorPage } from "Infrastructure/Pages/ApplicationErrorPage";
import { AppRouting } from "Infrastructure/Utils/UrlUtils";

type Props = {
  allowedRoles?: AccessRoleCode[];
};

export const AuthenticatedRoute = ({
  children,
  allowedRoles,
}: React.PropsWithChildren<Props>): React.ReactNode => {
  const { isAuthenticated, isLoading, hasRole } = useCurrentUser();
  const location = useLocation();

  if (isLoading) return <div />;

  if (!isAuthenticated) {
    return (
      <Navigate
        to={AppRouting.SignIn.path()}
        state={{ from: location.pathname }}
        replace
      />
    );
  }

  if (allowedRoles && !allowedRoles.some(hasRole)) {
    return <Navigate to={AppRouting.Dashboard.path()} replace />;
  }

  return (
    <ErrorBoundary FallbackComponent={ApplicationErrorPage}>
      {children}
    </ErrorBoundary>
  );
};
